// Auto-generated queries for Recordings domain — DO NOT EDIT.

import type { QueryDef } from '@voicedojo/api';
import type { Recording } from './ReadModels.g.js';
import type { AiReviewId, RecordingId, SeriesId } from '../ids.g.js';

export interface FindRecordingByIdQuery {
  id: RecordingId;
}

export interface FindRecordingByReviewIdQuery {
  reviewId: AiReviewId;
}

export interface FindRecordingsBySeriesQuery {
  seriesId: SeriesId;
}

export interface FindRecordingsByUserQuery {
}

/** QueryDef descriptor for POST /api/query ($type: 'FindRecordingByIdQuery'). */
export const findRecordingById: QueryDef<FindRecordingByIdQuery, Recording> = {
  $type: 'FindRecordingByIdQuery',
  watch: 'Recording',
  key: 'id',
};

/** QueryDef descriptor for POST /api/query ($type: 'FindRecordingByReviewIdQuery'). */
export const findRecordingByReviewId: QueryDef<FindRecordingByReviewIdQuery, Recording> = {
  $type: 'FindRecordingByReviewIdQuery',
  watch: 'Recording',
};

/** QueryDef descriptor for POST /api/query ($type: 'FindRecordingsBySeriesQuery'). */
export const findRecordingsBySeries: QueryDef<FindRecordingsBySeriesQuery, Recording> = {
  $type: 'FindRecordingsBySeriesQuery',
  watch: 'Recording',
};

/** QueryDef descriptor for POST /api/query ($type: 'FindRecordingsByUserQuery'). */
export const findRecordingsByUser: QueryDef<FindRecordingsByUserQuery, Recording> = {
  $type: 'FindRecordingsByUserQuery',
  watch: 'Recording',
};

